import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AppUpdateService } from '../../core/services/app-update.service';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouteType } from '../../core/enums/route-type.enum';
import { ProfileType, VisaTypes } from '../../core/enums/visa-types.enum';
import { BusinessSignInComponent } from "./business-auth/business-sign-in/business-sign-in.component";
import { globalDatas } from '../../../assets/data/globals';
import { GovernmentSignInComponent } from "./government-auth/government-sign-in/government-sign-in.component";
import { FamilySignInComponent } from "./family-auth/family-sign-in/family-sign-in.component";
import { FamilySignUpComponent } from "./family-auth/family-sign-up/family-sign-up.component";

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SignUpComponent,
    SignInComponent,
    ForgotPasswordComponent,
    TranslateModule,
    BusinessSignInComponent,
    ReactiveFormsModule,
    RouterModule,
    GovernmentSignInComponent,
    FamilySignInComponent,
    FamilySignUpComponent
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {
  authForm!: FormGroup;
  routeVisaType = RouteType
  //remove after khaleeji 26
  currentImage: string = '';
  ProfileType = ProfileType;
  profileTypeList = globalDatas.PROFILE_TYPE_LIST;
  visaTypeControl = new FormControl(ProfileType.Individual, [Validators.required]);
  authTitle!: string;
  routeType = RouteType;
  selectedVisaType: string = '';
  visaTypes = VisaTypes;
  visaTypeList = [
    {
      visaType: VisaTypes.TOURIST,
      visaTypeImage: 'assets/images/dashboard/tourist.png',
      visaTypename: 'VISA_DETAILS.VISA_TYPE.TOURIST'
    },
    {
      visaType: VisaTypes.FAMILY,
      visaTypeImage: 'assets/images/dashboard/family.png',
      visaTypename: 'VISA_DETAILS.VISA_TYPE.FAMILY'
    },
    {
      visaType: VisaTypes.BUSINESS,
      visaTypeImage: 'assets/images/dashboard/business.png',
      visaTypename: 'VISA_DETAILS.VISA_TYPE.WORK'
    },
    {
      visaType: VisaTypes.GOVERNMENT,
      visaTypeImage: 'assets/images/dashboard/government.png',
      visaTypename: 'VISA_DETAILS.VISA_TYPE.GOVERNMENT'
    }
  ];
  private readonly appUpdateService = inject(AppUpdateService);

  constructor(
    public router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.appUpdateService.checkOnLandingPage();
    this.setTitle();
    switch (this.router.url) {
      case '/sign-up':
        this.selectedVisaType = VisaTypes.TOURIST;
        break;
      case '/forgot-password':
        this.selectedVisaType = VisaTypes.TOURIST;
        break;
      case this.routeType.BUSINESS_SIGN_IN:
      case this.routeType.BUSINESS_PAYMENT_SIGN_IN:
        this.selectedVisaType = VisaTypes.BUSINESS;
        break;
      case this.routeType.GOVERNMENT_SIGN_IN:
      case this.routeType.GOVERNMENT_PAYMENT_SIGN_IN:
        this.selectedVisaType = VisaTypes.GOVERNMENT;
        break;
      case this.routeType.FAMILY_SIGN_IN:
      case this.routeType.FAMILY_PAYMENT_SIGN_IN:
        this.selectedVisaType = VisaTypes.FAMILY;
        break;
      case this.routeType.FAMILY_SIGN_UP:
        this.selectedVisaType = VisaTypes.FAMILY;
        break;
      default:
        this.selectedVisaType = VisaTypes.TOURIST;
        break;
    }
    this.updateImage(window.innerWidth);
  }
  //remove after khaleeji 26
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateImage(event.target.innerWidth);
  }

  //remove after khaleeji 26
  private updateImage(width: number) {
    this.currentImage = width < 576
      ? 'assets/images/khaleeji-banner-mobile-1.svg'
      : 'assets/images/khaleeji-banner-1.svg';
  }

  onSelectVisaType(visaType) {
    this.setTitle();
    this.selectedVisaType = visaType;
    switch (visaType) {
      case VisaTypes.BUSINESS: this.router.navigate([this.routeType.BUSINESS_SIGN_IN]);
        break;
      case VisaTypes.GOVERNMENT: this.router.navigate([this.routeType.GOVERNMENT_SIGN_IN]);
        break;
      case VisaTypes.FAMILY: this.router.url.includes("/sign-up") ? this.router.navigate([this.routeType.FAMILY_SIGN_UP]) : this.router.navigate([this.routeType.FAMILY_SIGN_IN]);
        break;
      default: this.router.url.includes("/sign-up") ? this.router.navigate(['/sign-up']) : this.router.navigate(['/sign-in']);
        break;
    }
  }

  setTitle() {
    if (this.router.url.includes('/forgot-password')) {
      this.authTitle = this.route.snapshot.queryParams['data'] ? 'AUTH.RESET_PASSWORD_TITLE' : 'AUTH.FORGOT_TITLE';
    }
    else {
      if (this.router.url.includes("/sign-up")) {
        this.authTitle = 'AUTH.SIGN_UP_TITLE';
      }
      else {
        this.authTitle = 'AUTH.LOGIN_TITLE';
      }
    }
  }
}
